export enum Role {
  SuperAdmin = 'super_admin',
  Admin = 'admin',
  Instructor = 'instructor',
  Student = 'student',
}

export enum VideoCallType {
  OnboardingCall = 'onboarding',
  CourseCall = 'course',
}

export type SubscriptionStatus = 'trialing' | 'active' | 'canceled' | 'past_due';

export enum ScheduledCallStatus {
  pending = 'pending',
  accepted = 'accepted',
  rejected = 'rejected',
}
